export default "__VITE_ASSET__C9kA9qaG__";